module.exports = __webpack_public_path__ + "static/media/md-bed.25813fa6.svg";